import mapKeys from 'lodash/mapKeys';
import snakeCase from 'lodash/snakeCase';
import { PostSource } from '../../data-layer/posts/constants';
import type { PostPersistenceDto, PostPersistenceModel } from '../../data-layer/posts/types';

export const toPostPersistenceDto = (model: PostPersistenceModel): PostPersistenceDto => ({
    text: model.text,
    media: model.media,
    business_id: model.businessId,
    data_source: model.source ?? PostSource.MANUAL,
    clickouts: model.clickouts?.map(
        (clickout) => mapKeys(clickout, (_, key) => snakeCase(key)) as any,
    ),
    status: model.status,
});
